<template>
    <div class="flex flex-col items-center space-y-4">
      <!-- Баллы -->
      <div class="text-xl font-bold">Баллы: {{ score }}</div>
  
                    <!-- Контейнер с картинкой -->
       <div class="relative w-[800px] h-[500px] overflow-hidden rounded-2xl shadow-lg border">
         <canvas
           ref="canvasRef"
           width="800"
           height="500"
           class="w-full h-full"
         ></canvas>
         
         
       </div>
  
             <!-- Кнопка для открытия картинки -->
       <button
         @click="revealImage"
         :disabled="overlayPercent >= 100 || answered"
         class="px-4 py-2 bg-blue-500 text-white rounded-xl shadow hover:bg-blue-600 disabled:opacity-50"
       >
         Открыть ещё (+10%)
       </button>
  
      <!-- Варианты ответов -->
      <div class="grid grid-cols-2 gap-3 mt-4 w-full max-w-md">
        <button
          v-for="(option, idx) in currentQuestion?.options || []"
          :key="idx"
          @click="checkAnswer(option)"
          class="px-4 py-2 bg-gray-200 rounded-xl shadow hover:bg-gray-300 disabled:opacity-50"
          :disabled="answered"
        >
          {{ option }}
        </button>
      </div>
  
      <!-- Сообщение -->
      <div v-if="answered" class="mt-4 text-lg font-semibold">
        {{ message }}
      </div>
    </div>
  </template>
  
  <script setup>
import { ref, onMounted, watch } from "vue"

const questions = ref([])
const currentQuestion = ref(null)
const canvasRef = ref(null)

const overlayPercent = ref(10)
const score = ref(0)
const answered = ref(false)
const message = ref("")
const shuffledPositions = ref([]) // Сохраняем перемешанный порядок позиций
  
  // Загружаем вопросы из JSON
  onMounted(async () => {
    const res = await fetch("../questions.json")
    questions.value = await res.json()
    
    // Исправляем пути к изображениям
    questions.value.forEach((question, index) => {
      if (index === 0) {
        question.image = new URL('../sprites/FizPic/krugNaVode.jpeg', import.meta.url).href
      } else if (index === 1) {
        question.image = new URL('../sprites/FizPic/molniya.jpg', import.meta.url).href
      }
    })
    
    pickRandomQuestion()
  })
  
  function pickRandomQuestion() {
    answered.value = false
    overlayPercent.value = 10
    shuffledPositions.value = [] // Сбрасываем позиции для нового вопроса
    console.log('Reset overlay to:', overlayPercent.value)
    if (questions.value.length > 0) {
      const idx = Math.floor(Math.random() * questions.value.length)
      currentQuestion.value = questions.value[idx]
    }
    // Отрисовываем изображение после выбора вопроса
    setTimeout(() => {
      drawImageWithOverlay()
    }, 100)
  }
  
  function revealImage() {
    if (overlayPercent.value < 100) {
      overlayPercent.value += 10
    }
  }
  
                   // Функция для отрисовки изображения с перекрытием
    function drawImageWithOverlay() {
      if (!canvasRef.value || !currentQuestion.value) return
      
      const canvas = canvasRef.value
      const ctx = canvas.getContext('2d')
      
      // Очищаем canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      
      // Создаём изображение
      const img = new Image()
      img.onload = () => {
        // Вычисляем размеры для правильного масштабирования
        const canvasAspect = canvas.width / canvas.height
        const imgAspect = img.width / img.height
        
        let drawWidth, drawHeight, offsetX, offsetY
        
        if (imgAspect > canvasAspect) {
          // Изображение шире, чем canvas
          drawHeight = canvas.height
          drawWidth = img.width * (canvas.height / img.height)
          offsetX = (canvas.width - drawWidth) / 2
          offsetY = 0
        } else {
          // Изображение выше, чем canvas
          drawWidth = canvas.width
          drawHeight = img.height * (canvas.width / img.width)
          offsetX = 0
          offsetY = (canvas.height - drawHeight) / 2
        }
        
                 // Рисуем изображение с правильным масштабированием
         ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight)
         
                             // Создаём сетку квадратиков, покрывающую всю область изображения
          const squareSize = 20 // Размер квадратика
          const cols = Math.ceil(drawWidth / squareSize)
          const rows = Math.ceil(drawHeight / squareSize)
          const totalSquares = cols * rows
          
          // Вычисляем сколько квадратиков нужно убрать (показать)
          const squaresToRemove = Math.floor(totalSquares * (1 - overlayPercent.value / 100))
          
          console.log('Total squares:', totalSquares)
          console.log('Overlay percent:', overlayPercent.value, '%')
          console.log('Squares to remove:', squaresToRemove)
          
          // Создаём массив всех позиций квадратиков (только если ещё не создан)
          if (shuffledPositions.value.length === 0) {
            const allPositions = []
            for (let row = 0; row < rows; row++) {
              for (let col = 0; col < cols; col++) {
                allPositions.push({
                  x: offsetX + col * squareSize,
                  y: offsetY + row * squareSize
                })
              }
            }
            
            // Перемешиваем массив для случайного порядка и сохраняем
            shuffledPositions.value = [...allPositions]
            for (let i = shuffledPositions.value.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1))
              ;[shuffledPositions.value[i], shuffledPositions.value[j]] = [shuffledPositions.value[j], shuffledPositions.value[i]]
            }
          }
          
          // Убираем первые squaresToRemove квадратиков из сохранённого порядка
          ctx.globalCompositeOperation = 'destination-out'
          for (let i = 0; i < squaresToRemove; i++) {
            const pos = shuffledPositions.value[i]
            ctx.fillRect(pos.x, pos.y, squareSize, squareSize)
          }
          
          // Возвращаем нормальный режим
          ctx.globalCompositeOperation = 'source-over'
      }
      img.src = currentQuestion.value.image
    }

  // Следим за изменениями overlayPercent
  watch(overlayPercent, () => {
    drawImageWithOverlay()
  })

  // Следим за изменениями currentQuestion
  watch(currentQuestion, () => {
    drawImageWithOverlay()
  })

  function checkAnswer(option) {
    answered.value = true
    if (option === currentQuestion.value.correct) {
      // Вычисляем баллы: от 10 до 100 в зависимости от открытого изображения
      // При overlayPercent = 10% (мало видно) = 100 баллов
      // При overlayPercent = 90% (много видно) = 10 баллов
      const points = Math.max(10, Math.min(100, Math.floor(100 - (overlayPercent.value - 10) * (90 / 80))))
      score.value += points
      message.value = `Правильно! +${points} очков`
    } else {
      message.value = "Неверно!"
    }

    // через 1.5 секунды переключаем на новый вопрос
    setTimeout(() => {
      pickRandomQuestion()
    }, 1500)
  }
  </script>
  